<template>
  <div id="app">
    <el-container :class="{ 'not-auth': !this.$store.state.auth.isLoggedIn }">
      <el-header class="header">
        <el-row class="header__inner">
          <el-col :span="12">
            <div class="elsa-logo">
              <img src="@/assets/images/elsa-dashboard-logo.svg" alt="Elsa Now" />
            </div>
          </el-col>

          <el-col :span="12" v-if="this.$store.state.auth.isLoggedIn" id="nav-right">
            <user-dropdown />
          </el-col>
        </el-row>
      </el-header>
      <el-container>
        <el-aside
          v-if="this.$store.state.auth.isLoggedIn && $route.name != 'admin' && $route.name != 'comming-soon'"
          width="240px"
        >
          <el-menu :default-active="activeNav" class="el-menu-vertical-demo" ref="menu">
            <el-menu-item index="1" v-if="canAccessGetSetup">
              <router-link
                id="left-navigation-get-set-up-button"
                :to="'/admin/organization/' + currentOrganizationId + '/onboarding'"
              >
                <rocket-icon width="50px" />
                <span>{{ $t("menu.get_set_up") }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="12" v-if="canAccessInsights">
              <router-link
                id="left-navigation-dashboard-button"
                :to="{
                  name: 'insights',
                  params: { organizationId: currentOrganizationId },
                }"
              >
                <dashboard-icon width="50px" />
                <span>Insights</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="7" v-if="canAccessDashboard">
              <router-link
                id="left-navigation-dashboard-button"
                :to="{
                  name: 'dashboard',
                  params: { organizationId: currentOrganizationId },
                }"
              >
                <dashboard-icon width="50px" />
                <span>{{ $t("menu.dashboard") }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="3" v-if="canAccessClasses">
              <router-link
                id="left-navigation-classes-button"
                :to="{
                  name: 'classes',
                  params: { organizationId: currentOrganizationId },
                }"
              >
                <team-icon width="50px" />
                <span>{{ $t($i18nLabelsHelper(currentOrganizationType, "groups")) }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="4" v-if="canAccessTeachers">
              <router-link
                id="left-navigation-teachers-button"
                :to="{
                  name: 'teachers',
                  params: { organizationId: currentOrganizationId },
                }"
              >
                <team-lead-icon width="48px" style="padding-left:2px" />
                <span>{{ $t($i18nLabelsHelper(currentOrganizationType, "teachers")) }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="9" v-if="canAccessCurriculum">
              <router-link
                id="left-navigation-plan-button"
                :to="{
                  name: 'studysets',
                  params: { organizationId: currentOrganizationId },
                }"
              >
                <curriculum-icon width="47px" style="padding-left:3px" />
                <span>{{ $t("menu.curriculum") }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="5" v-if="canAccessStudents">
              <router-link
                id="left-navigation-students-button"
                :to="{
                  name: 'students',
                  params: { organizationId: currentOrganizationId },
                }"
              >
                <learners-icon width="47px" style="padding-left:3px" />
                <span>{{ $t("menu.learners") }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="6" v-if="canAccessPlanPayment">
              <router-link
                id="left-navigation-plan-button"
                :to="'/admin/organization/' + currentOrganizationId + '/plan'"
              >
                <payment-icon width="50px" />
                <span>{{ $t("menu.plan_payment") }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="2" v-if="isElsaAdmin || isOrganizationAdmin">
              <router-link id="left-navigation-account-button" :to="'/admin/organization/' + currentOrganizationId">
                <setting-icon width="50px" />
                <span>{{ $t("menu.account") }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item hidden index="10" v-show="isShowMenuBranches">
              <router-link
                id="left-navigation-account-button"
                :to="'/organization/' + currentOrganizationId + '/branches'"
              >
                <organization-icon width="47px" style="padding-left:3px" />
                <span>{{ $t("menu.branch") }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="8" v-if="isElsaAdmin">
              <router-link id="left-navigation-organizations-button" to="/admin">
                <organization-icon width="47px" style="padding-left:3px" />
                <span>{{ $t("menu.organizations") }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="11" v-if="isElsaAdmin && currentOrganizationId">
              <router-link
                id="left-navigation-organizations-button"
                :to="'/admin/organization/' + currentOrganizationId + '/internal-payment'"
              >
                <payment-icon width="50px" />
                <span>{{ $t("menu.internal_payment") }}</span>
              </router-link>
            </el-menu-item>
            <!-- <el-menu-item index="9" v-if="isElsaAdmin">
              <router-link id="left-navigation-homework-button" :to="`/organization/${currentOrganizationId}/assignment/new`">
                <span>Homework Assignment</span>
              </router-link>
            </el-menu-item> -->
          </el-menu>
        </el-aside>

        <invite />
        <!-- <session-expired />-->
        <router-view />
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { path, includes } from "ramda";
import { mapGetters } from "vuex";
import Invite from "@/components/common/Invite";
// import SessionExpired from "@/components/common/SessionExpired";
import UserDropdown from "@/components/common/UserDropdown";
import learnersIcon from "@/assets/images/inline.profile-icon.svg";
import settingIcon from "@/assets/images/inline.setting-icon.svg";
import organizationIcon from "@/assets/images/inline.organization-icon.svg";
import teamIcon from "@/assets/images/inline.team-icon.svg";
import rocketIcon from "@/assets/images/inline.rocket-icon.svg";
import paymentIcon from "@/assets/images/inline.payment-icon.svg";
import dashboardIcon from "@/assets/images/inline.dashboard-icon.svg";
import teamLeadIcon from "@/assets/images/inline.team-lead-icon.svg";
import curriculumIcon from "@/assets/images/inline.curriculum-icon.svg";

export default {
  components: {
    Invite,
    // SessionExpired,
    UserDropdown,
    learnersIcon,
    teamIcon,
    rocketIcon,
    paymentIcon,
    settingIcon,
    dashboardIcon,
    teamLeadIcon,
    organizationIcon,
    curriculumIcon,
  },
  data() {
    return {
      activeNav: "1",
      navConfig: {
        onboarding: "1",
        dashboard: "7",
        classes: "3",
        teachers: "4",
        students: "5",
        organizationplan: "6",
        organization: "2",
        insights: "12",
      },
      watchRoute: true,
      isEmptyOrg: false,
      SARoutes: ["students", "account"],
      nonOrgRoutes: ["admin", "comming-soon"],
    };
  },
  computed: {
    ...mapGetters("user", ["isElsaAdmin"]),
    ...mapGetters("organization", [
      "isOrganizationAdmin",
      "isOrganizationAssociateAdmin",
      "isOrganizationTeacher",
      "isOrganizationStudent",
      // "currentOrganization",  // Moved to v2
      // "currentOrganizationId",
      "currentOrganizationType",
      "currentOrgPayment",
      "userOrganizations",
      "hasChildOrg",
      "isElsaSpeakProduct",
      "SAonly",
      "isNovaOrg",
    ]),
    currentOrganizationId() {
      let organizationId = this.$store.state.organization.currentOrganizationId;
      // if (organizationId) {
      //   // get org info whenever organizationId is set
      //   this.$store.dispatch('org/getCurrentOrganization', { organizationId })
      // }
      return organizationId;
    },
    currentOrganization() {
      return this.$store.state.organization.currentOrganization;
    },
    canAccessCurriculum() {
      return (
        (this.isOrganizationTeacher || this.isOrganizationAdmin || this.isOrganizationAssociateAdmin) &&
        this.currentOrganizationId &&
        this.isElsaSpeakProduct && !this.isNovaOrg
      );
    },
    canAccessClasses() {
      return (
        (this.isOrganizationAdmin ||
          this.isOrganizationAssociateAdmin ||
          this.$store.getters["organization/hasOrganizations"]) &&
        this.currentOrganizationId &&
        this.isElsaSpeakProduct
      );
    },
    canAccessTeachers() {
      return (
        (this.isOrganizationAdmin || this.isOrganizationAssociateAdmin) &&
        this.currentOrganizationId &&
        this.isElsaSpeakProduct
      );
    },
    canAccessStudents() {
      return (
        (this.isOrganizationTeacher || this.isOrganizationAdmin || this.isOrganizationAssociateAdmin) &&
        this.currentOrganizationId
      );
    },
    canAccessDashboard() {
      return ((this.isElsaAdmin && this.currentOrganizationId) || (!this.isElsaAdmin && this.isElsaSpeakProduct)) && !this.isNovaOrg;
    },
    canAccessGetSetup() {
      return (
        (this.isElsaAdmin || this.isOrganizationAdmin || this.isOrganizationAssociateAdmin || this.isEmptyOrg) &&
        this.isElsaSpeakProduct
      );
    },
    canAccessPlanPayment() {
      return (this.isElsaAdmin || this.isOrganizationAdmin) && this.isElsaSpeakProduct && !this.isNovaOrg;
    },
    isShowMenuBranches() {
      if(!this.hasChildOrg) return false
      return this.hasChildOrg && (this.isElsaAdmin || this.isOrganizationAdmin)
    },
    canAccessInsights() {
      return this.isNovaOrg;
    },
  },
  watch: {
    async $route(to, from) {
      let forceActiveNav;
      // @TODO: double check organization belong to current user
      const toOrganizationId = path(["params", "organizationId"], to);
      if (toOrganizationId && /^\d+$/.test(toOrganizationId)) {
        if (Object.keys(this.currentOrganization).length === 0) {
          await this.$store.dispatch("organization/setCurrentOrganization", {
            organizationId: Number(toOrganizationId),
          });
          this.$store.dispatch("organization/setCurrentOrganizationId", {
            organizationId: Number(toOrganizationId),
          });
        }
        if (this.SAonly && !includes(to.name)(this.SARoutes)) {
          this.$router.push(`/admin/organization/${toOrganizationId}/students`);
        }
      } else {
        // can not get org id from url
        if (this.$store.state.auth.isLoggedIn && !this.nonOrgRoutes.includes(to.name)) {
          // get first url
          // check in store
          let _toOrganizationId = this.currentOrganizationId;
          // If empty, get first from userOrganizations list
          if (!_toOrganizationId && this.userOrganizations && this.userOrganizations.length > 0) {
            _toOrganizationId = this.userOrganizations[0].id;
          }
          // move to org onboarding
          if (_toOrganizationId) {
            this.$router.push(`/admin/organization/${_toOrganizationId}/onboarding`);
          } else {
            // move to empty onboarding
            this.isEmptyOrg = true;
            forceActiveNav = "1";
            this.$router.push(`/onboarding`);
          }
        }
      }
      if (this.$recaptchaInstance) {
        if (to.name === "Login") {
          this.$recaptchaInstance.showBadge();
        } else {
          this.$recaptchaInstance.hideBadge();
        }
      }
      if (this.watchRoute || from.name === "admin" || from.name === "Login") {
        if (forceActiveNav) {
          this.activeNav = forceActiveNav;
        } else {
          if (to.name in this.navConfig) {
            this.activeNav = this.navConfig[to.name];
          } else if (to.meta && to.meta.menuItemIndex) {
            this.activeNav = to.meta.menuItemIndex;
          }
        }
        this.watchRoute = false;
      }

      document.title = to.meta.title || this.$t("common.elsa_dashboard");
      if (to.meta.menuItemIndex && this.activeNav && !forceActiveNav && to.meta.menuItemIndex !== this.activeNav) {
        this.activeNav = to.meta.menuItemIndex;
      }
    },
  },
};
</script>
<style lang="scss">
@import "./scss/global.scss";
.el-container {
  min-height: calc(100vh - 80px);
}
.user-menu {
  p {
    margin: 0;
    line-height: 1;
    &.description {
      text-transform: uppercase;
      color: $light-blue-2;
      font-size: 10px;
      margin-bottom: 16px;
    }
    &.link {
      font-size: 16px;
      text-transform: capitalize;
      color: $gray;
      font-weight: 500;
      cursor: pointer;

      &:not(.logout) {
        margin-bottom: 32px;
      }
      &.logout {
        border-top: 1px solid rgba(206, 224, 234, 0.5);
        padding-top: 16px;
        padding-bottom: 8px;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
          text-decoration-color: $purple;
        }
      }
    }
  }
}

.logout-link {
  cursor: pointer;
  font-size: 14px;
  text-transform: capitalize;
  color: #eb5757;
}

.divider {
  border-width: 2px;
}

.switch-lang {
  margin: 0 20px;
}

@media only screen and (max-width: 768px) {
  .switch-lang {
    margin-bottom: -5px;
    position: absolute;
    top: 5px;
    right: 5px;
  }
}

.header {
  height: 64px !important;
  margin-top: 16px;
  border-bottom: solid 1px #e6e6e6;

  .header__inner {
    display: flex;
  }
}

.el-menu-item {
  font-size: 16px;
  line-height: 48px;
  height: 48px;
  color: #121131;
  font-weight: 500;
  margin-bottom: 8px;
  border-radius: 8px;
}

ul.el-menu-vertical-demo.el-menu {
  padding-left: 16px;
  padding-top: 16px;
  padding-right: 16px;
  background-color: #ffffff !important;
  height: 100%;
}

ul.el-menu-vertical-demo.el-menu li a {
  display: block;
  width: calc(100% + 20px);
  margin-left: -20px;
  padding-left: 20px;
}

.el-menu-item:hover,
.el-menu-item:focus {
  border-radius: 8px;
  font-weight: 700;
}

.el-menu-item.is-active,
.el-menu-item.is-active:hover {
  color: #007eff;
  background-color: RGB(71, 141, 255, 0.1) !important;
  border-radius: 8px;

  svg {
    filter: invert(42%) sepia(78%) saturate(1707%) hue-rotate(202deg) brightness(104%) contrast(101%);
  }
}

#left-navigation-dashboard-button {
  svg {
    width: 50px;
  }
}

.user-badge {
  text-align: right;
}

.el-menu-item a {
  color: inherit;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
}

.not-auth {
  .el-header {
    display: none !important;
  }
  .el-container {
    display: block;
  }
  .switch-lang {
    position: absolute;
    right: 52%;
    top: 43px;
    z-index: 999;
  }
}
.el-aside {
  position: sticky;
  top: 0;
  max-height: 100vh;
  overflow: hidden;
}

#nav-right {
  margin: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
